import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../StuStyles/StudentProfile.css";
import { useNavigate, useLocation } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";

import profilepic from "../../../assets/board3.jpg";
import idimg from "../../../assets/img1.png";

import ApiService from "../../../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

const TporegView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const membershipId =
    location.state?.membershipId ||
    location.state?.id ||
    null;

  const [data, setData] = useState(null);
  const [member, setMember] = useState({});
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);

  /* =========================
     FETCH API DATA
  ========================== */
  useEffect(() => {
    if (membershipId) {
      fetchRepresentative();
    } else {
      setLoading(false);
    }
  }, [membershipId]);

  const fetchRepresentative = async () => {
    try {
      const res = await AdminAPI.getMemberById(membershipId);

      console.log("FULL API RESPONSE =>", res.data);

      /*
        API FORMAT:
        {
          member: {},
          details: {}
        }
      */

      const responseData = res.data || {};

      const memberData = responseData.member || {};
      const detailsData = responseData.details || {};

      setMember(memberData);
      setDetails(detailsData);

      setData(responseData);

      console.log("MEMBER DATA =>", memberData);
      console.log("DETAILS DATA =>", detailsData);

    } catch (err) {
      console.error("API ERROR:", err);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     PROFILE IMAGE HANDLER
  ========================== */
  const getProfileImage = (img) => {
    if (!img) return profilepic;

    if (typeof img === "string") {
      return img.startsWith("http")
        ? img
        : `https://nhrc.onrender.com/${img}`;
    }

    return profilepic;
  };

  /* =========================
     ID CARD IMAGE HANDLER
  ========================== */
  const getIdCardImage = (img) => {
    if (!img) return idimg;

    if (typeof img === "string") {
      return img.startsWith("http")
        ? img
        : `https://nhrc.onrender.com/${img}`;
    }

    return idimg;
  };

  /* =========================
     NO MEMBERSHIP ID
  ========================== */
  if (!membershipId) {
    return (
      <div className="container mt-5 text-center">

        <h4>No Representative Data Found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>

      </div>
    );
  }

  /* =========================
     LOADING
  ========================== */
  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <h5>Loading...</h5>
      </div>
    );
  }

  /* =========================
     NO DATA
  ========================== */
  if (!data) {
    return (
      <div className="container mt-5 text-center">

        <h4>No Details Found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>

      </div>
    );
  }

  return (
    <div className="container student-profile-container mt-5 mb-0">

      {/* ================= HEADER ================= */}
      <div className="d-flex justify-content-between align-items-center mb-4">

        <h4 className="fw-bold mt-3">
          REPRESENTATIVE REGISTRATION
        </h4>

      </div>

      {/* ================= BACK BUTTON ================= */}
      <button
        className="jobback"
        style={{ width: "80px" }}
        onClick={() => navigate(-1)}
      >
        <TiArrowBack />
        Back
      </button>

      {/* ================= PERSONAL DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Personal Details
        </h5>

        <div className="row g-3 mt-2">

          {/* PROFILE PIC */}
          <div className="col-md-4">

            <label className="form-label">
              Profile Pic
            </label>

            <div>
              <img
                src={getProfileImage(member.profile_pic)}
                alt="profile"
                className="profile-pic"
                onError={(e) => {
                  e.target.src = profilepic;
                }}
              />
            </div>

          </div>

          {/* FULL NAME */}
          <div className="col-md-4">

            <label className="form-label">
              Full Name
            </label>

            <input
              className="form-control"
              value={member.full_name || ""}
              readOnly
            />

          </div>

          {/* EMAIL */}
          <div className="col-md-4">

            <label className="form-label">
              Email
            </label>

            <input
              className="form-control"
              value={member.email || ""}
              readOnly
            />

          </div>

          {/* DOB */}
          <div className="col-md-4">

            <label className="form-label">
              Date Of Birth
            </label>

            <input
              className="form-control"
              value={member.dob || ""}
              readOnly
            />

          </div>

          {/* GENDER */}
          <div className="col-md-4">

            <label className="form-label">
              Gender
            </label>

            <input
              className="form-control"
              value={member.gender || ""}
              readOnly
            />

          </div>

          {/* BLOOD GROUP */}
          <div className="col-md-4">

            <label className="form-label">
              Blood Group
            </label>

            <input
              className="form-control"
              value={member.blood_group || ""}
              readOnly
            />

          </div>

          {/* STATE */}
          <div className="col-md-4">

            <label className="form-label">
              State
            </label>

            <input
              className="form-control"
              value={member.state || ""}
              readOnly
            />

          </div>

          {/* DISTRICT */}
          <div className="col-md-4">

            <label className="form-label">
              District
            </label>

            <input
              className="form-control"
              value={member.district || ""}
              readOnly
            />

          </div>

          {/* PINCODE */}
          <div className="col-md-4">

            <label className="form-label">
              Pincode
            </label>

            <input
              className="form-control"
              value={member.pincode || ""}
              readOnly
            />

          </div>

          {/* MOBILE */}
          <div className="col-md-4">

            <label className="form-label">
              Mobile Number
            </label>

            <input
              className="form-control"
              value={member.mobile || ""}
              readOnly
            />

          </div>

          {/* MEMBERSHIP ID */}
          <div className="col-md-4">

            <label className="form-label">
              Membership ID
            </label>

            <input
              className="form-control"
              value={member.membership_id || ""}
              readOnly
            />

          </div>

          {/* STATUS */}
          <div className="col-md-4">

            <label className="form-label">
              Status
            </label>

            <input
              className="form-control"
              value={member.status || ""}
              readOnly
            />

          </div>

        </div>

      </div>

      {/* ================= REPRESENTATIVE DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Representative Details
        </h5>

        <div className="row g-3 mt-2">

          {/* UNIVERSITY NAME */}
          <div className="col-md-4">

            <label className="form-label">
              University Name
            </label>

            <input
              className="form-control"
              value={details.university_name || ""}
              readOnly
            />

          </div>

          {/* COLLEGE NAME */}
          <div className="col-md-4">

            <label className="form-label">
              College Name
            </label>

            <input
              className="form-control"
              value={details.college_name || ""}
              readOnly
            />

          </div>

          {/* COLLEGE CODE */}
          <div className="col-md-4">

            <label className="form-label">
              College Code
            </label>

            <input
              className="form-control"
              value={details.college_code || ""}
              readOnly
            />

          </div>

          {/* DEPARTMENT */}
          <div className="col-md-4">

            <label className="form-label">
              Department
            </label>

            <input
              className="form-control"
              value={details.department || ""}
              readOnly
            />

          </div>

          {/* DESIGNATION */}
          <div className="col-md-4">

            <label className="form-label">
              Designation
            </label>

            <input
              className="form-control"
              value={details.designation || ""}
              readOnly
            />

          </div>

          {/* EXPERIENCE */}
          <div className="col-md-4">

            <label className="form-label">
              Experience
            </label>

            <input
              className="form-control"
              value={details.experience || ""}
              readOnly
            />

          </div>

          {/* UNIVERSITY ADDRESS */}
          <div className="col-md-4">

            <label className="form-label">
              University Address
            </label>

            <input
              className="form-control"
              value={details.university_address || ""}
              readOnly
            />

          </div>

          {/* OFFICIAL MAIL */}
          <div className="col-md-4">

            <label className="form-label">
              Official Mail ID
            </label>

            <input
              className="form-control"
              value={details.official_mail_id || ""}
              readOnly
            />

          </div>

          {/* ID CARD PROOF */}
          <div className="col-md-4">

            <label className="form-label">
              ID Card Proof
            </label>

            <div>
              <img
                src={getIdCardImage(
                  details.id_card ||
                  details.id_proof ||
                  details.id_front ||
                  details.profile_pic
                )}
                alt="ID Proof"
                className="id-proof-img"
                onError={(e) => {
                  e.target.src = idimg;
                }}
              />
            </div>

          </div>

          {/* PERSONAL EMAIL */}
          <div className="col-md-4">

            <label className="form-label">
              Personal Mail ID
            </label>

            <input
              className="form-control"
              value={member.email || ""}
              readOnly
            />

          </div>

          {/* MOBILE NUMBER */}
          <div className="col-md-4">

            <label className="form-label">
              Mobile Number
            </label>

            <input
              className="form-control"
              value={
                details.mobile_number ||
                member.mobile ||
                ""
              }
              readOnly
            />

          </div>

          {/* DISTRICT */}
          <div className="col-md-4">

            <label className="form-label">
              District
            </label>

            <input
              className="form-control"
              value={details.district || ""}
              readOnly
            />

          </div>

          {/* STATE */}
          <div className="col-md-4">

            <label className="form-label">
              State
            </label>

            <input
              className="form-control"
              value={details.state || ""}
              readOnly
            />

          </div>

          {/* PINCODE */}
          <div className="col-md-4">

            <label className="form-label">
              Pincode
            </label>

            <input
              className="form-control"
              value={details.pincode || ""}
              readOnly
            />

          </div>

        </div>

      </div>

      {/* ================= DEBUG API RESPONSE ================= */}
      <div className="card p-3 mb-4">

        <h5 className="mb-3">
          Debug API Response
        </h5>

        <pre
          style={{
            fontSize: "12px",
            overflow: "auto",
          }}
        >
          {JSON.stringify(data, null, 2)}
        </pre>

      </div>

    </div>
  );
};

export default TporegView;